import { render, staticRenderFns } from "./EditSkillPage.vue?vue&type=template&id=58e28ac1&"
import script from "./EditSkillPage.vue?vue&type=script&lang=js&"
export * from "./EditSkillPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports